import React from "react"

interface IPropsFromParent {
  children: React.ReactNode
  className?: string
  isDark?: boolean
  noBorder?: boolean
}

type IProps = IPropsFromParent

const DetailsCardWithNested: React.FC<IProps> = ({
  children,
  className,
  isDark = false,
  noBorder
}: IProps): JSX.Element => {
  const defaultClasses = [
    "flex",
    "flex-col",
    "mb-2",
    "rounded-md",
    "p-4",
    { "border border-ch-gray-400": !noBorder }
  ]

  const backgroundColourClass = isDark ? "bg-ch-gray-300" : "bg-white"
  const propClasses = className ? className.split(" ") : []
  const allClasses = [...defaultClasses, backgroundColourClass, ...propClasses].join(" ")

  return (
    <div className={allClasses}>
      {children}
    </div>
  )
}

export default DetailsCardWithNested
